<template>
  <div :class="$style.block">
    <div :class="$style.container">
      <h4 class="line-title" data-anim="stagger">{{ content.title }}</h4>
      <ul :class="$style.list">
        <li data-anim="fade" v-for="(icon, i) in content.icons" :key="i">
          <a rel="noopener" target="_blank" :href="icon.url">
            <img :src="icon.image" :alt="icon.title">
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['content']
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";

.block {
  background: $color-dark;

  h4 {
    margin-bottom: $standard-margin-mobile;

    @include mq(sm) {
      margin-bottom: $standard-margin;
    }
  }
}

.container {
  @include grid-size();
  // padding: $giga-margin-mobile;
  padding: $giga-margin-mobile 30px 30px;

  @include mq(sm) {
    padding: $giga-margin;
  }
}

.list {
  display: flex;
  flex-flow: row wrap;

  li {
    position: relative;
    width: 90px;
    margin: 20px auto;

    @include mq(sm) {
      width: 100px;
      margin: 20px;
    }

    @include mq(lg) {
      margin: 25px;
    }

    @include mq(hg) {
      margin: 35px;
    }

    a {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: all 0.4s ease-out;

      :global(.no-touchevents) &:hover {
        opacity: 0.7;
      }
    }

    &::before {
      content: "";
      display: block;
      width: 100%;
      padding-bottom: 100%;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      margin: 0 auto;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LogosBlock.vue